import { Input, Modal } from "antd";
import React, { useState } from "react";
import { svg } from "../../../../../Assets/svg";
import { momentFullTime } from "../../../../../helpers/utils";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { BtnLoader } from "../../../../../Components/Components";

const ChangeLabelQtyModal: React.FC<{
  visible: boolean;
  setIsModalVisible: any;
  editData: any;
  dymo: any;
  setPreviewImage: any;
  setEditData: any;
}> = ({
  visible,
  setIsModalVisible,
  editData,
  dymo,
  setPreviewImage,
  setEditData,
}) => {
  const onClose = () => {
    setIsModalVisible(false);
    setEditData(null);
  };
  console.log(editData,"editDataeditDataeditDataeditData")
  const [editQtyLoading, setEditQtyLoading] = useState(false);
  const handleSave = async (values: any) => {
    try {
      setEditQtyLoading(true);

      const newXml = editData?.XML.replace(
        `QUANTITY - ${editData?.label_data?.printed_data?.extra_data?.quantity || editData?.data?.qty|| 0}`,
        `QUANTITY - ${values?.qty || 0}`,
      );

      const result = await dymo.renderLabel(newXml);

      let base64: any = typeof result === "object" ? result.data : result;

      if (base64) {
        base64 = base64.replace(/"/g, "");
        const baseData = base64.startsWith("data:image")
          ? base64
          : `data:image/png;base64,${base64}`;

        const newData = {
          ...editData,
          XML: newXml,
          preview: baseData,
          data: {
            qty: values?.qty,
          },
          label_data: {
              ...editData?.label_data,
              printed_data: {
                ...(editData?.label_data?.printed_data || {}),
                extra_data: {
                   quantity: Number(values?.qty),
                },
              },
            },
        };

        setPreviewImage((prev: any) =>
          prev?.map((elem: any) => (elem?.id == editData?.id ? newData : elem)),
        );
        onClose();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setEditQtyLoading(false);
    }
  };

  const rowSaveSchema = Yup.object().shape({
    qty: Yup.number()
      .typeError("Qty must be a number")
      .required("Qty is required")
      .positive("Qty must be greater than 0"),
  });
  return (
    <Modal
      title={<div className="text-center fs-4 fw-bolder lh-m">Change Qty</div>}
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4 mt-3">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={editQtyLoading}
          >
            CLOSE
          </button>
          <button
            disabled={editQtyLoading}
            className="btn btn-lg btn-primary min-w-130"
            form="labelQtyModal"
          >
            {editQtyLoading ? <BtnLoader /> : "SAVE"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <Formik
        initialValues={{
          qty: editData?.label_data?.printed_data?.extra_data?.quantity ||editData?.data?.qty||0,
        }}
        validationSchema={rowSaveSchema}
        onSubmit={handleSave}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          setFieldValue,
        }: any) => {
          return (
            <Form
              id="labelQtyModal"
              onSubmit={handleSubmit}
              className="page-form"
            >
              <div className="row gy-3">
                <div className="col-md-12">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff d-flex align-items-center justify-content-between">
                      Quantity{" "}
                    </label>
                    <Field
                      name="qty"
                      type="number"
                      min={1}
                      className="form-control form-control-lg"
                      placeholder={"Enter Quantity"}
                      onWheel={(e: any) => e.currentTarget.blur()}
                      as={Input}
                      onKeyDown={(e: any) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        if (
                          allowedKeys.includes(e.key) ||
                          (e.key >= "0" && e.key <= "9")
                        ) {
                          return;
                        }

                        e.preventDefault();
                      }}
                    />
                    {errors?.qty && (
                      <div className="text-danger fs-8">{errors?.qty}</div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default ChangeLabelQtyModal;
